var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    fillRule: "evenodd",
    d: "M19.427 21.427a8.5 8.5 0 1 1 2-2l5.585 5.585c.55.55.546 1.43 0 1.976l-.024.024a1.4 1.4 0 0 1-1.976 0zM14.5 21a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13"
  })));
};
export default SvgSearch;